import { modelOptions, post, prop } from "@typegoose/typegoose";
import { z } from "zod";
import { getZodSchemaFromClass, validate } from "../../../zod-decorator/index.js";
import { addSchemaKeyHook, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";
import type { SignalMetricsFieldsWithDefaults, SignalMetricsSchemaTypes } from "../../types/signalMetrics.d.js";
import { type DtoValidatorTypes } from "../../validatableClass.js";

const SCHEMA_KEY = "SignalMetrics" as const;

// TODO: convert to responseOnly schema class
@modelOptions({ schemaOptions: { _id: false } })
@post<SchemaBase<SignalMetrics>>(...addSchemaKeyHook(SCHEMA_KEY))
export class SignalMetrics extends SchemaBase<SignalMetrics, SignalMetricsFieldsWithDefaults> {
    static readonly schemaKey = SCHEMA_KEY;

    @validate({ schemaKey: SCHEMA_KEY })
    readonly schemaKey = SCHEMA_KEY;

    @validate({ zodValidator: z.string(), responseOnly: true })
    @prop({ type: () => String, required: true })
    public gatewayEui!: string;

    @validate({ zodValidator: z.number(), responseOnly: true })
    @prop({ type: () => Number, required: true })
    public rssi!: number;

    @validate({ zodValidator: z.number(), responseOnly: true })
    @prop({ type: () => Number, required: true })
    public snr!: number;

    static dtoValidators: DtoValidatorTypes<SignalMetricsSchemaTypes>;

    constructor(properties?: SchemaConstructorArgs<SignalMetrics, SignalMetricsFieldsWithDefaults>) {
        super(properties);
        Object.assign(this, properties);
    }
}

SignalMetrics.dtoValidators = getZodSchemaFromClass(
    SignalMetrics,
) as unknown as DtoValidatorTypes<SignalMetricsSchemaTypes>;
